export enum NHG {
    Ja = 'ja',
    Nee = 'nee',
}
